import { render, staticRenderFns } from "./PurpleBlue.vue?vue&type=template&id=075cdd04&scoped=true&"
import script from "./PurpleBlue.vue?vue&type=script&lang=js&"
export * from "./PurpleBlue.vue?vue&type=script&lang=js&"
import style0 from "./PurpleBlue.vue?vue&type=style&index=0&id=075cdd04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075cdd04",
  null
  
)

export default component.exports